<section id="financial-hardship-page" class="w-full min-h-screen bg-ld-neutral-50">
  <div class="max-w-page mx-auto py-6 page-content-padding">
    <header id="financial-hardship-header" class="mb-6">
      <h1 id="financial-hardship-title" class="text-page-title">
        {{ 'financialHardshipTitle' | transloco }}
      </h1>
      <p id="financial-hardship-subtitle" class="text-base text-ld-neutral-500 mt-1">
        {{ 'financialHardshipSubtitle' | transloco }}
      </p>
    </header>

    <div
      id="financial-hardship-scam-alert"
      class="bg-amber-50 border border-amber-300 rounded-lg p-4 mb-6"
      role="alert"
    >
      <h2 id="financial-hardship-scam-alert-title" class="text-card-title text-ld-neutral mb-2">
        {{ 'financialHardshipScamAlertTitle' | transloco }}
      </h2>
      <p id="financial-hardship-scam-alert-text" class="text-body text-ld-neutral-700 leading-relaxed">
        {{ 'financialHardshipScamAlertText1' | transloco }}
        <a
          id="financial-hardship-scam-alert-phone"
          [href]="customerServiceTel()"
          class="text-ld-link font-medium hover:underline cursor-pointer"
        >
          {{ customerServicePhone() }}
        </a>
        {{ 'financialHardshipScamAlertText2' | transloco }}
      </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-6">
      <div id="financial-hardship-content-section" class="flex flex-col gap-6">
        <div id="financial-hardship-trouble-section">
          <h2 id="financial-hardship-trouble-title" class="text-section-heading text-ld-neutral mb-4">
            {{ 'financialHardshipTroubleMakingPaymentsTitle' | transloco }}
          </h2>

          <p id="financial-hardship-trouble-text-1" class="text-body text-ld-neutral-700 leading-relaxed mb-4">
            {{ 'financialHardshipTroubleMakingPaymentsText1' | transloco }}
          </p>

          <p id="financial-hardship-trouble-text-2" class="text-body text-ld-neutral-700 leading-relaxed mb-4">
            {{ 'contactUsHereToHelpText3' | transloco }}
            <a
              id="financial-hardship-hud-phone"
              [href]="hudCounselingTel"
              class="text-ld-link font-medium hover:underline cursor-pointer"
            >
              {{ 'financialHardshipTroubleMakingPaymentsPhone1' | transloco }}.
            </a>
          </p>

          <p id="financial-hardship-trouble-text-3" class="text-body text-ld-neutral-700 leading-relaxed mb-4">
            {{ 'contactUsHereToHelpText4' | transloco }}
            <a
              id="financial-hardship-wa-phone"
              [href]="waHotlineTel"
              class="text-ld-link font-medium hover:underline cursor-pointer"
            >
              {{ 'financialHardshipTroubleMakingPaymentsPhone2' | transloco }}.
            </a>
            {{ 'financialHardshipTroubleMakingPaymentsText4' | transloco }}
          </p>

          <p id="financial-hardship-trouble-text-4" class="text-body text-ld-neutral-700 leading-relaxed mb-3">
            {{ 'financialHardshipTroubleMakingPaymentsText5' | transloco }}
          </p>

          <div id="financial-hardship-info-docs" class="flex flex-col gap-2 mt-2">
            @for (doc of infoDocuments; track doc.textKey; let i = $index) {
              <a
                [id]="'financial-hardship-info-doc-' + i"
                href="javascript:void(0)"
                class="inline-flex items-center gap-2 text-sm text-ld-link font-medium hover:underline cursor-pointer"
                (click)="openDocument($event, doc.url)"
              >
                <mat-icon class="size-5! text-xl! text-ld-link" aria-hidden="true">picture_as_pdf</mat-icon>
                {{ doc.textKey | transloco }}
              </a>
            }
          </div>
        </div>

        <div id="financial-hardship-options-section">
          <h2 id="financial-hardship-options-title" class="text-section-heading text-ld-neutral mb-4">
            {{ 'financialHardshipOptionsTitle' | transloco }}
          </h2>

          <div class="bg-white rounded-lg shadow-card border border-ld-neutral-200 overflow-hidden">
            @for (option of paymentOptions; track option.key; let i = $index; let last = $last) {
              <mat-expansion-panel
                [id]="'financial-hardship-option-' + i"
                class="m-0! shadow-none! rounded-none!"
                [expanded]="isPanelExpanded(option.key)"
                (opened)="togglePanel(option.key)"
                (closed)="isPanelExpanded(option.key) && togglePanel(option.key)"
                hideToggle
              >
                <mat-expansion-panel-header
                  [id]="'financial-hardship-option-header-' + i"
                  class="px-4! py-3! min-h-12! cursor-pointer"
                >
                  <mat-panel-title
                    class="text-sm! font-dm! font-semibold! mr-4!"
                    [class.text-ld-primary!]="isPanelExpanded(option.key)"
                    [class.text-ld-neutral!]="!isPanelExpanded(option.key)"
                  >
                    {{ option.titleKey | transloco }}
                  </mat-panel-title>
                  <mat-icon
                    class="text-ld-neutral-500 transition-transform duration-200"
                    [class.rotate-180]="isPanelExpanded(option.key)"
                  >
                    expand_more
                  </mat-icon>
                </mat-expansion-panel-header>

                <div class="px-4 pb-4">
                  <p
                    [id]="'financial-hardship-option-details-' + i"
                    class="text-sm text-ld-neutral-600 leading-relaxed"
                  >
                    {{ option.detailsKey | transloco }}
                  </p>
                  @if (option.details2Key) {
                    <p
                      [id]="'financial-hardship-option-details2-' + i"
                      class="text-sm text-ld-neutral-600 leading-relaxed mt-2"
                    >
                      {{ option.details2Key | transloco }}
                    </p>
                  }
                </div>
              </mat-expansion-panel>
              @if (!last) {
                <hr class="border-ld-neutral-200 m-0" />
              }
            }
          </div>
        </div>

        <div id="financial-hardship-forms-section">
          <h2 id="financial-hardship-forms-title" class="text-section-heading text-ld-neutral mb-4">
            {{ 'financialHardshipFormsTitle' | transloco }}
          </h2>

          <p id="financial-hardship-forms-description" class="text-body text-ld-neutral-700 leading-relaxed mb-4">
            {{ 'financialHardshipFormsDescription' | transloco }}
          </p>

          <div class="bg-white rounded-lg shadow-card border border-ld-neutral-200 p-4">
            <p id="financial-hardship-forms-download-title" class="text-card-title text-ld-neutral mb-3">
              {{ 'financialHardshipFormsDownloadTitle' | transloco }}
            </p>

            <div id="financial-hardship-form-docs" class="flex flex-col gap-2 mb-4">
              @for (doc of formDocuments; track doc.textKey; let i = $index) {
                <a
                  [id]="'financial-hardship-form-doc-' + i"
                  href="javascript:void(0)"
                  class="inline-flex items-center gap-2 text-sm text-ld-link font-medium hover:underline cursor-pointer"
                  (click)="openDocument($event, doc.url)"
                >
                  <mat-icon class="size-5! text-xl! text-ld-link" aria-hidden="true">picture_as_pdf</mat-icon>
                  {{ doc.textKey | transloco }}
                </a>
              }
            </div>

            <p id="financial-hardship-forms-upload-text" class="text-sm text-ld-neutral-700 mb-4">
              {{ 'financialHardshipFormsUploadText' | transloco }}
            </p>

            <button
              id="financial-hardship-upload-btn"
              type="button"
              class="btn-primary-ld-purple gap-2 mb-4"
              (click)="openUploadDialog()"
            >
              <mat-icon class="size-5! text-xl!">file_upload</mat-icon>
              {{ 'financialHardshipFormsUploadButton' | transloco }}
            </button>

            <div id="financial-hardship-contact-support">
              <button
                id="financial-hardship-contact-support-btn"
                type="button"
                class="inline-flex items-center gap-1 text-sm text-ld-link font-medium hover:underline cursor-pointer bg-transparent border-none p-0"
                (click)="openSecureMessage('Question')"
              >
                {{ 'financialHardshipFormsContactSupport' | transloco }}
                <mat-icon class="size-5! text-xl!" aria-hidden="true">arrow_forward</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <aside id="financial-hardship-sidebar" class="flex flex-col gap-6">
        <ld-contact-card />
      </aside>
    </div>
  </div>

  @if (showComposeMessage()) {
    <div
      id="financial-hardship-compose-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="financial-hardship-compose-title"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-60 max-sm:bg-white max-sm:top-[calc(env(safe-area-inset-top)+60px)] max-sm:bottom-[calc(env(safe-area-inset-bottom)+60px)]"
      (keydown.escape)="onCloseComposeMessage()"
    >
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <div
        id="financial-hardship-compose-modal"
        class="bg-white rounded-card shadow-modal w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden max-sm:mx-0 max-sm:rounded-none max-sm:max-h-full max-sm:h-full max-sm:shadow-none"
        (click)="$event.stopPropagation()"
      >
        @defer (when showComposeMessage()) {
          <ld-compose-message
            [prefillCategory]="composePrefillCategory"
            [prefillTopic]="composePrefillTopic()"
            (closed)="onCloseComposeMessage()"
          ></ld-compose-message>
        }
      </div>
    </div>
  }
</section>
